import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeodestinosService } from '@cms-app/geodestinos';
var AdminRestaurantsComponent = /** @class */ (function () {
    function AdminRestaurantsComponent(router, geodestinosService) {
        this.router = router;
        this.geodestinosService = geodestinosService;
        this.rows = [];
        this.count = 0;
        this.page = 1;
        this.per_page = 20;
        this.query = '';
        this.loading = false;
    }
    AdminRestaurantsComponent.prototype.ngOnInit = function () {
        this.find();
    };
    AdminRestaurantsComponent.prototype.checkLink = function (row) {
        window.open(row.url, '_blank');
    };
    AdminRestaurantsComponent.prototype.update = function (row) {
        this.router.navigate(['admin', 'geodestinos', 'geodestino-detail', 'comer', row._id], {
            state: {
                data: row,
                type: 'comer'
            }
        });
    };
    AdminRestaurantsComponent.prototype.onPage = function (_a) {
        var offset = _a.offset;
        this.page = offset + 1;
        this.find();
    };
    AdminRestaurantsComponent.prototype.onQuery = function (query) {
        this.query = query;
        this.find();
    };
    AdminRestaurantsComponent.prototype.find = function () {
        var _this = this;
        this.loading = true;
        this.geodestinosService
            .fetch('comer', this.query && this.query.length > 0 ? { q: this.query } : {}, { page: this.page || 1, per_page: this.per_page })
            .subscribe(function (_a) {
            var list = _a.list, count = _a.count;
            _this.rows = list;
            _this.count = count;
            _this.loading = false;
        }, function () {
            _this.loading = false;
        });
    };
    AdminRestaurantsComponent.prototype.onAdd = function () {
        this.router.navigate(['admin', 'geodestinos', 'geodestino-detail', 'comer', 'new']);
    };
    return AdminRestaurantsComponent;
}());
export { AdminRestaurantsComponent };
